export const APP_FEATURE_KEY = 'app';
